import formatAndDropDecimal from './formatAndDropDecimal';

export function getMonthlyPaymentDescription({
  hasValidSoftPull,
  isFinanceInitialized,
  maxMonthlyPayment
}: {
  hasValidSoftPull: boolean;
  isFinanceInitialized: boolean;
  maxMonthlyPayment: number;
}) {
  return isFinanceInitialized && hasValidSoftPull
    ? `Your financing terms limit your monthly payment to no more than $${formatAndDropDecimal(
        maxMonthlyPayment
      )}.`
    : undefined;
}

export function getCashDownDescription({
  hasValidSoftPull,
  isFinanceInitialized,
  hasAppliedTrade,
  minDownPayment,
  minDownPaymentNoTrade = 0
}: {
  hasValidSoftPull: boolean;
  isFinanceInitialized: boolean;
  hasAppliedTrade: boolean;
  minDownPayment: number;
  minDownPaymentNoTrade?: number;
}) {
  if (!isFinanceInitialized || !hasValidSoftPull) return undefined;

  if (hasAppliedTrade) {
    if (minDownPayment === 0 && minDownPaymentNoTrade === 0) {
      return 'Your financing terms do not require a minimum down payment.';
    } else if (minDownPayment === minDownPaymentNoTrade) {
      return `Your financing terms require a minimum down payment of $${formatAndDropDecimal(
        minDownPayment
      )} or more.`;
    } else if (minDownPayment > minDownPaymentNoTrade) {
      return `Including your trade-in increases your required minimum down payment from $${formatAndDropDecimal(
        minDownPaymentNoTrade
      )} to $${formatAndDropDecimal(minDownPayment)}.`;
    } else if (minDownPayment < minDownPaymentNoTrade) {
      return `Including your trade-in reduces your required minimum down payment from $${formatAndDropDecimal(
        minDownPaymentNoTrade
      )} to $${formatAndDropDecimal(minDownPayment)}.`;
    }
  }

  return minDownPayment === 0
    ? 'Your financing terms do not require a minimum down payment.'
    : `Your financing terms require a minimum down payment of $${formatAndDropDecimal(
        minDownPayment
      )} or more.`;
}
